export enum MethodType {
  "GET" = "GET",
  "POST" = "POST",
  "PUT" = "PUT",
  "DELETE" = "DELETE",
  "PATCH" = "PATCH",
}
export interface ResponseInterface<T> {
  data?: T;
  message?: string;
  status: number;
  headers?: any;
}

export enum KeyURL {
  login = "login",
  scorm = "scorm",
  xapi = "xapi",
  achievements = "achievements",
  permissions = "permissions",
  smartconfigurator = "smartconfigurator",
  corporate = "corporate",
  corporateCustomFields = "corporateCustomFields",
  corporates = "corporates",
  categories = "categories",
  categoriesSorting = "categoriesSorting",
  putCategoriesSorting = "putCategoriesSorting",
  organization_tree = "organizationTree",
  corporate_organization_tree = "corporateOrganizationTree",
  groups = "groups",
  staticGroups = "staticGroups",
  attributes = "attributes",
  dynamicGroups = "dynamicGroups",
  activities = "activities",
  activities_digited = "activitiesDigited",
  catalogCorporateAssociation = "catalogCorporateAssociation",
  catalogCorporateDisassociation = "catalogCorporateDisassociation",
  catalogDomainAssociation = "catalogDomainAssociation",
  catalogDomainDisassociation = "catalogDomainDisassociation",
  catalogTimeZones = "catalogTimeZones",
  learningObjectsStandAlone = "learningObjectsStandAlone",
  skills = "skills",
  locations = "locations",
  sites = "sites",
  rooms = "rooms",
  visibility_cones = "visibilityCones",
  initiative = "initiative",
  topics = "topics",
  path = "path",
  path_digited = "pathDigited",
  customer = "customer",
  digited_users = "digitedUsers",
  digited_users_campaign_delete = "digitedUsersCampaignDelete",
  digited_campaign = "digitedCampaign",
  digited_tipology_campaign = "digitedTipologyCampaign",
  digited_role_user = "digitedRoleUser",
  digited_campaign_levels = "digitedCampaignLevels",
  digited_detail_campaign = "digitedDetailCampaign",
  digited_detail_campaign_add = "digitedDetailCampaignAdd",
  digited_campaign_report = "digitedCampaignReport",
  digited_detail_campaign_learner = "digitedDetailCampaignLearner",
  digited_detail_campaign_learner_confirm_gap = "digitedDetailCampaignGapManagementLearnerGap",
  digited_detail_campaign_learner_delete_knowledge = "digitedDetailCampaignLearnerDeleteKnowledge",
  digited_delete_detail_campaign = "digitedDeleteDetailCampaign",
  digited_campaign_users = "digitedUsersCampaign",
  reminder_users_campaign = "reminderUsersCampaign",
  faculties = "faculties",
  users = "users",
  courses = "courses",
  courses_digited = "coursesDigited",
  duplicateCourse = "duplicateCourse",
  educatinal_formats_digited = "educationalFormatsDigited",
  catalogCategoryAssociation = "catalogCategoryAssociation",
  catalogTopicAssociation = "catalogTopicAssociation",
  catalogCategoryDisassociation = "catalogCategoryDisassociation",
  catalogTopicDisassociation = "catalogTopicDisassociation",
  usersDomain = "usersDomain",
  static_groups = "static-groups",
  library = "library",
  external_vendors = "external-vendors",
  editorialText = "editorialText",
  enrollment = "enrollment",
  getEnrollmentGroupLo = "getEnrollmentGroupLo",
  getEnrollmentsDownload = "getEnrollmentsDownload",
  getEnrollmentsDownloadTemplate = "getEnrollmentsDownloadTemplate",
  postEnrollmentsUpload = "postEnrollmentsUpload",
  group_initiative_association = "group_initiative_association",
  user_initiative_association = "user-initiative-association",
  course_category_association = "course-category-association",
  path_category_association = "path-category-association",
  activity_category_association = "activity-category-association",
  course_topic_association = "course-topic-association",
  activity_topic_association = "activity-topic-association",
  path_topic_association = "path-topic-association",
  physical_editions = "physical-editions",
  virtual_editions = "virtual-editions",
  learning_catalogue = "learning-catalogue",
  badge_id = "badges",
  budget_id = "budgets",
}

export enum KeyUserURL {
  getFaculties = "getFaculties",
  postFaculty = "postFaculty",
  postFaculties = "postFaculties",
  putFaculties = "putFaculties",
  putFacultiesDownload = "putFacultiesDownload",
  getCustomer = "getCustomer",
  postCustomer = "postCustomer",
  postCustomers = "postCustomers",
  postCampaign = "postCampaign",
  putCustomer = "putCustomer",
  deleteCustomer = "deleteCustomer",
  putCustomerStatus = "putCustomerStatus",
  corporateLanguages = "corporateLanguages",
  getCorporateCustomFields = "getCorporateCustomFields",
  postCorporateCustomFields = "postCorporateCustomFields",
  getFacultiesDownload = "getFacultiesDownload",
  getCustomersDownload = "getCustomersDownload",
  getCustomersDownloadTemplate = "getCustomersDownloadTemplate",
  getCustomersDownloadV3 = "getCustomersDownloadV3",
}

export enum KeyPathsURL {
  getPaths = "getPaths",
  postPaths = "postPaths",
  putPath = "putPath",
  duplicatePath = "duplicatePath",
  getActivityAssociation = "getActivityAssociation",
  getCoursesAssociation = "getCoursesAssociation",
  getPathChildren = "getPathChildren",
}

export enum KeyCoursesURL {
  getCourses = "getCourses",
  getCourseChildren = "getCourseChildren",
}

export enum KeyCertificateBadgesURL {
  getBadges = "getBadges",
  getCertificates = "getCertificates",
  getPlaceholders = "getPlaceholders",
  getIssuedCertificatesZip = "getIssuedCertificatesZip",
  getIssuedCertificate = "getIssuedCertificate",
  getExternalCertificate = "getExternalCertificate",
  putExternalCertificate = "putExternalCertificate",
  downloadExternalCertificateAttachments = "downloadExternalCertificateAttachments",
  deleteExternalCertificate = "deleteExternalCertificate",
  getSkillBook = "getSkillBook",
  getSingleExternalTraining = "getSingleExternalTraining",
  downloadExternalTrainingAttachments = "downloadExternalTrainingAttachments",
  getExternalTrainings = "getExternalTrainings",
  postExternalTrainings = "postExternalTrainings",
  postExternalTrainingMassive = "postExternalTrainingMassive",
  approveRejectExternalTraining = "approveRejectExternalTraining",
  getTotalTrainingRequests = "getTotalTrainingRequests",
  getDetailTrainingRequests = "getDetailTrainingRequests",
  getCertificate = "getCertificate",
  getCourseType = "getCourseType",
  postApproveRequest = "postApproveRequest",
  postSkillBook = "postSkillBook",
  postSkillBookMassive = "postSkillBookMassive",
}
export enum KeyEnrollmentURL {
  getEnrollment = "getEnrollment",
  postEnrollment = "postEnrollment",
  deleteEnrollment = "deleteEnrollment",
  patchEnrollment = "patchEnrollment",
  postEnrollmentMassive = "postEnrollmentMassive",
  postGroupEnrollmentMassive = "postGroupEnrollmentMassive",
  deleteGroupEnrollmentMassive = "deleteGroupEnrollmentMassive",
  getEnrollmentMassive = "getEnrollmentMassive",
  getEnrollHistory = "getEnrollHistory",
  getEnrollEditionDetail = "getEnrollEditionDetail",
  getEnrollEdition = "getEnrollEdition",
  downloadEnrolledEdition = "downloadEnrolledEdition",
  getLOBasedOnStudentId = "getLOBasedOnStudentId",
  customTracking = "customTracking",
  getEnrollmentsDownload = "getEnrollmentsDownload",
  getEnrollmentsDownloadTemplate = "getEnrollmentsDownloadTemplate",
  postEnrollmentsUpload = "postEnrollmentsUpload",
  getStaticGroups = "getStaticGroups",
  postGroupEnrollmentUpload = "postGroupEnrollmentUpload",
}

export enum KeyEnrollmentRemainderURL {
  getEnrollmentRemainder = "getEnrollmentRemainder",
  postEnrollmentRemainder = "postEnrollmentRemainder",
  postEnrollmentMassiveRemainder = "postEnrollmentMassiveRemainder",
}

export enum KeyEnrollmentSuggestedURL {
  getEnrollmentSuggested = "getEnrollmentSuggested",
  postEnrollmentSuggested = "postEnrollmentSuggested",
  postEnrollmentMassiveSuggested = "postEnrollmentMassiveSuggested",
}

export enum KeyActivitiesURL {
  getActivities = "getActivities",
  getFormats = "getFormats",
  postActivities = "postActivities",
  putActivities = "putActivities",
  duplicateActivities = "duplicateActivities",
  getLTIAccounts = "getLTIAccounts",
}

export enum KeySmartConfiguratorURL {
  getDownloadSmartConfigurator = "getDownloadSmartConfigurator",
  getSmartConfigurator = "getSmartConfigurator",
  getDetailSmartConfigurator = "getDetailSmartConfigurator",
  patchDetailSmartConfigurator = "patchDetailSmartConfigurator",
  postSmartconfigurator = "postSmartconfigurator",
  genericSmartConfigurator = "genericSmartConfigurator",
  smartconfigurator_brandingAsset = "smartconfigurator-brandingAsset",
  smartconfigurator_template_mail = "smartconfigurator-template-mail",
  smartconfigurator_notifications = "smartconfigurator-notifications",
  smartconfiguratorDownloadTemplate = "smartconfiguratorDownloadTemplate",
  getSmartConfiguratorMaintenancePage = "getSmartConfiguratorMaintenancePage",
  postSmartConfiguratorMaintenancePage = "postSmartConfiguratorMaintenancePage",
}
export enum KeyPermissionsURL {
  getSelftPermissions = "getSelftPermissions",
  postPermissions = "postPermissions",
  putPermissions = "putPermissions",
}

export enum KeyDashboardURL {
  getQuicksightDashboard = "getQuicksightDashboard",
  getDashboard = "getDashboard",
  enableDisableDashboard = "enableDisableDashboard",
  associateCorporate = "associateCorporate",
  associateUsers = "associateUsers",
  associateRoles = "associateRoles",
  editDashboard = "editDashboard",
  getAssociations = "getAssociations",
}

export enum KeyEditionURL {
  getEditionsDetail = "getEditionsDetail",
  getEditions = "getEditions",
  postEditions = "postEditions",
  deleteVirtual = "deleteVirtual",
  deletePhysical = "deletePhysical",
  getEditionsNotDeletable = "getEditionsNotDeletable",
  uploadParticipants = "uploadParticipants",
  downloadParticipants = "downloadParticipants",
  downloadTemplateParticipants = "downloadTemplateParticipants",
  getVirtualRegister = "getVirtualRegister",
  getVirtualRegisterFile = "getVirtualRegisterFile",
  postVirtualRegisterFile = "postVirtualRegisterFile",
  getVirtualRegisterHistory = "getVirtualRegisterHistory",
  getVirtualRegisterHistoryFile = "getVirtualRegisterHistoryFile",
  attendancePresence = "attendancePresence",
  invitationStatus = "invitationStatus",
  invitationStatusSession = "invitationStatusSession",
  updateMeetingParticipation = "updateMeetingParticipation",
  attendanceReport = "attendanceReport",
  getReasonCodes = "getReasonCodes",
  getEditionEnrollmentsDownload = "getEditionEnrollmentsDownload",
  getEditionEnrollmentsTemplate = "getEditionEnrollmentsTemplate",
  postEditionEnrollmentsUpload = "postEditionEnrollmentsUpload",
}

export enum keyOnboarding {
  postWelcomemail = "postWelcomemail",
}

export enum keyMediaManager {
  uploadAdminTheme = "uploadAdminTheme",
}

export enum keySessionManager {
  getSessionByID = "getSessionByID",
  postSessionByID = "postSessionByID",
  getSessionCognito = "getSessionCognito",
}
export enum keyAssociatedLo {
  loAssociated = "loAssociated",
}

export enum keyWrapper {
  postWrapper = "postWrapper",
}

export enum keyCommunity {
  getTerms = "getTerms",
  getDiscussion = "getDiscussion",
  getForum = "getForum",
}

export enum keyUsersWaiting {
  getUsersWaiting = "getUsersWaiting",
  patchUsersApproveDeny = "patchUsersApproveDeny",
}

export enum keyIndustries {
  getIndustries = "getIndustries",
  postIndustries = "postIndustries",
  putIndustries = "putIndustries",
}

export enum keyProfessions {
  getProfessions = "getProfessions",
  postProfessions = "postProfessions",
  putProfessions = "putProfessions",
  putProfessionsObsolete = "putProfessionsObsolete",
}

export enum keyJobs {
  getJobs = "getJobs",
  postJobs = "postJobs",
  putJobs = "putJobs",
  putJobsObsolete = "putJobsObsolete",
  getAllJobs = "getAllJobs",
}

export enum keyKnowledgeAreas {
  getKnowledgeAreas = "getKnowledgeAreas",
  postKnowledgeAreas = "postKnowledgeAreas",
  putKnowledgeAreas = "putKnowledgeAreas",
  putKnowledgeAreasObsolete = "putKnowledgeAreasObsolete",
}

export enum keyKnowledgeDomains {
  getKnowledgeDomainsAll = "getKnowledgeDomainsAll",
  getKnowledgeDomainsId = "getKnowledgeDomainsId",
  getKnowledgeDomains = "getKnowledgeDomains",
  postKnowledgeDomains = "postKnowledgeDomains",
  putKnowledgeDomains = "putKnowledgeDomains",
  putKnowledgeDomainsObsolete = "putKnowledgeDomainsObsolete",
}
export enum keyCapabilities {
  getCapabilities = "getCapabilities",
  postCapabilities = "postCapabilities",
  putCapabilities = "putCapabilities",
  putCapabilitiesObsolete = "putCapabilitiesObsolete",
}

export enum keyAttributes {
  getAttributes = "getAttributes",
}

export enum KeyknowledgeDomainJobs {
  getKnowledgeDomainJob = "getKnowledgeDomainJob",
  postKnowledgeDomainJob = "postKnowledgeDomainJob",
  deleteKnowledgeDomainJob = "deleteKnowledgeDomainJob",
}

export enum keySurvey {
  getSurvey = "getSurvey",
  postSurvey = "postSurvey",
  putSurvey = "putSurvey",
  deleteSurvey = "deleteSurvey",
}

export enum keyNotifications {
  getNotifications = "getNotifications",
  getNotification = "getNotification",
  getEvents = "getEvents",
  getUsersExcludedTemplate = "getUsersExcludedTemplate",
  postNotifications = "postNotifications",
  putNotifications = "putNotifications",
  deleteNotification = "deleteNotification",
  enableDisableNotification = "enableDisableNotification",
  downloadNotificationAttachments = "downloadNotificationAttachments",
}

export enum keyTranslations {
  getTranslations = "getTranslations",
  postTranslations = "postTranslations",
}

export enum keySuggestionsKnowledgeDomains {
  getAllKnowledgeDomainsSuggestion = "getAllKnowledgeDomainsSuggestion",
  getAllKnowledgeDomainsNoPaginationSuggestion = "getAllKnowledgeDomainsNoPaginationSuggestion",
  postUploadKnowledgeDomainsSuggestion = "postUploadKnowledgeDomainsSuggestion",
  getTemplateKnowledgeDomainsSuggestion = "getTemplateKnowledgeDomainsSuggestion",
  postKnowledgeDomainsSuggestion = "postKnowledgeDomainsSuggestion",
  deteleKnowledgeDomainSuggestion = "deteleKnowledgeDomainSuggestion",
}
export enum keySuggestionsCapabilities {
  getAllCapabilitiesSuggestion = "getAllCapabilitiesSuggestion",
  getAllCapabilitiesNoPaginationSuggestion = "getAllCapabilitiesNoPaginationSuggestion",
  postUploadCapabilitiesSuggestion = "postUploadCapabilitiesSuggestion",
  getTemplateCapabilitiesSuggestion = "getTemplateCapabilitiesSuggestion",
  postCapabilitiesSuggestion = "postCapabilitiesSuggestion",
  deteleCapabilitySuggestion = "deteleCapabilitySuggestion",
}

export enum keyRuntastic {
  getRuntastic = "getRuntastic",
}
export enum keyTeachersAreaExercise {
  getExercises = "getExercises",
  getSingleExercise = "getSingleExercise",
  putExercise = "putExercise",
  postExercise = "postExercise",
  deleteExercise = "deleteExercise",
  getUploadUrl = "getUploadUrl",
  getSessionQRCode = "getSessionQRCode",
}
export enum keyTeachersAreaExerciseAssociation {
  getExercisesAssociation = "getExercisesAssociation",
  putExerciseAssociation = "putExerciseAssociation",
  getEditionsAssociable = "getEditionsAssociable",
}
export enum keyTeachersAreaRevision {
  getRevisions = "getRevisions",
  getSingleRevisions = "getSingleRevisions",
  putRevisions = "putRevisions",
  presignedRevision = "presignedRevision",
  downloadRevisionsFile = "downloadRevisionsFile",
  getrevisionsByEditions = "getrevisionsByEditions",
}
export enum keyTeachersAreaReport {
  getReport = "getReport",
  getSingleReport = "getSingleReport",
  putReport = "putReport",
}

export enum keyEditionTOJ {
  getTOJ = "getTOJ",
  postTOJ = `postTOJ`,
  getEditTOJ = `getEditTOJ`,
  putTOJ = `putTOJ`,
  getTOJManage = "getTOJManage",
  putTOJManage = "putTOJManage",
  deleteEnrollmentTOJ = "deleteEnrollmentTOJ",
  getUserEnrollCourseTOJ = "getUserEnrollCourseTOJ",
  postEnrollToTOJEdition = "postEnrollToTOJEdition",
  getEnrolledUserTOJEdition = "getEnrolledUserTOJEdition",
  getManageEnrollTOJ = "getManageEnrollTOJ",
  postManageEnrollTOJ = "postManageEnrollTOJ",
}

export enum keySelfSignupRules {
  getRule = "getRule",
  postRule = "postRule",
  putRule = "putRule",
  deleteRule = "deleteRule",
}

export enum keySelfSignupSteps {
  getFields = "getFields",
  getForm = "getForm",
  postForm = "postForm",
  putForm = "putForm",
}

export enum keyCorporates {
  getCorporate = "getCorporate",
  putCorporate = "putCorporate",
  getInitiativesUsers = "getInitiativesUsers",
  getDynamicGroupsUsers = "getDynamicGroupsUsers",
  corporateLanguages = "corporateLanguages",
  refreshDynamicGroups = "refreshDynamicGroups",
  refreshDynamicGroup = "refreshDynamicGroup",
}

export enum keyGroupsEnrolledCatalog {
  getGroupsEnrolledWithEnrollInfo = "getGroupsEnrolledWithEnrollInfo",
  getLOEnrolledWithEnrollInfo = "getLOEnrolledWithEnrollInfo",
  getGroupsEnrolledToLO = "getGroupsEnrolledToLO",
}

export enum keySoftwareVersioning {
  getVersioning = "getVersioning",
  getVersioningTagging = "getVersioningTagging",
  deleteVersioningTagging = "deleteVersioningTagging",
  postVersioningTagging = "postVersioningTagging",
  patchVersioningTagging = "patchVersioningTagging",
  patchVersioningTaggingAssociation = "patchVersioningTaggingAssociation",
  patchVersioningTaggingDeassociation = "patchVersioningTaggingDeassociation",
}

export enum keyTIMCatalogueExcalibur {
  getUploadPresignedRelations = "getUploadPresignedRelations",
  getUploadPresignedFrequency = "getUploadPresignedFrequency",
  getDownloadPresignedRelations = "getDownloadPresignedRelations",
  getDownloadPresignedFrequency = "getDownloadPresignedFrequency",
  getDownloadPresignedNeeds = "getDownloadPresignedNeeds",
}

export enum keyFoundedTraining {
  getAllPlans = "getAllPlans",
  addPlan = "addPlan",
  putPlan = "modifyPlan",
  getSinglePlan = "getPlan",
  deletePlan = "deletePlan",
  getAllProjects = "getAllProject",
  addProject = "addProject",
  getProject = "getProject",
  putProject = "modifyProject",
  deleteProject = "deleteProject",
  getAllModules = "getAllModules",
  addModule = "addModule",
  getModule = "getModule",
  putModule = "modifyModule",
  deleteModule = "deleteModule",
  fund = "fund",
}

export enum keyCollectCampaigns {
  createCampaign = "createCampaign",
  updateCampaign = "updateCampaign",
  deleteCampaign = "deleteCampaign",
  setCampaignOwners = "setCampaignOwners",
  getCampaignOwners = "getCampaignOwners",
  setCampaignLos = "setCampaignLos",
  setCampaignUsers = "setCampaignUsers",
  getCampaign = "getCampaign",
  getCampaignScores = "getCampaignScores",
  getCampaignUsers = "getCampaignUsers",
  getCampaignUserLos = "getCampaignUserLos",
  getCampaignLearningObjects = "getCampaignLearningObjects",
  findCampaigns = "findCampaigns",
  findCampaignsAdmin = "findCampaignsAdmin",
  findCampaignGroups = "findCampaignGroups",
  findCampaignExclusions = "findCampaignExclusions",
  createCampaignCertificateTemplate = "createCampaignCertificateTemplate",
  updateCampaignCertificateTemplate = "updateCampaignCertificateTemplate",
  getCampaignCertificateTemplate = "getCampaignCertificateTemplate",
  downloadCampaignCertificateTemplate = "downloadCampaignCertificateTemplate",
  downloadCampaignCertificate = "downloadCampaignCertificate",
  downloadCampaignCertificates = "downloadCampaignCertificates",
  getCampaignExternalTraining = "getCampaignExternalTraining",
  downloadCampaignCertificateDefaultTemplate = "downloadCampaignCertificateDefaultTemplate",
}

export enum keyCommunityClusters {
  createCommunityCluster = "createCommunityCluster",
  getCommunityCluster = "getCommunityCluster",
  updateCommunityCluster = "updateCommunityCluster",
  deleteCommunityCluster = "deleteCommunityCluster",
  linkCommunityCluster = "linkCommunityCluster",
  getCommunityClusters = "getCommunityClusters",
  getCorporateCommunityClusters = "getCorporateCommunityClusters",
  getCommunityClusterUsers = "getCommunityClusterUsers",
}

export enum keyLeaderboardClusters {
  createLeaderboardCluster = "createLeaderboardCluster",
  getLeaderboardCluster = "getLeaderboardCluster",
  updateLeaderboardCluster = "updateLeaderboardCluster",
  deleteLeaderboardCluster = "deleteLeaderboardCluster",
  linkLeaderboardCluster = "linkLeaderboardCluster",
  getLeaderboardClusters = "getLeaderboardClusters",
  getCorporateLeaderboardClusters = "getCorporateLeaderboardClusters",
  updatedLeaderboardClusterScoring = "updateLeaderboardClusterScoring",
  getLeaderboardClusterRanking = "getLeaderboardClusterRanking",
  getLeaderboardReport = "getLeaderboardReport",
}

export enum keyBudgetsURL {
  getBudgets = "getBudgets",
  getBankAccountList = "getBankAccountList",
  getBankAccountListAll = "getBankAccountListAll",
  getCostCenterList = "getCostCenterList",
  getCostCenters = "getCostCenters",
  postCostCenters = "postCostCenters",
  getBankAccounts = "getBankAccounts",
  postBankAccounts = "postBankAccounts",
  postBudget = "postBudget",
  getDescriptions = "getDescriptions",
  getCustomers = "getCustomers",
  postCustomers = "postCustomers",
  getScopes = "getScopes",
  postScopes = "postScopes",
  getProjects = "getProjects",
  postProjects = "postProjects",
  getProjectsCategorizations = "getProjectsCategorizations",
  postProjectsCategorizations = "postProjectsCategorizations",
  getProjectsLearningObject = "getProjectsLearningObject",
  postProjectsLearningObject = "postProjectsLearningObject",
  getProjectsContext = "getProjectsContext",
  postProjectsContext = "postProjectsContext",
  putProjectsContext = "putProjectsContext",
  getProjectsCost = "getProjectsCost",
  postProjectsCost = "postProjectsCost",
  getSuppliers = "getSuppliers",
  postSuppliers = "postSuppliers",
  getContracts = "getContracts",
  postContracts = "postContracts",
  getUserFile = "getUserFile",
  deleteUserFile = "deleteUserFile",
  getGoodsReceipts = "getGoodsReceipts",
  getGoodsReceiptsAll = "getGoodsReceiptsAll",
  postGoodsReceipts = "postGoodsReceipts",
  getBookKeepingStats = "getBookKeepingStats",
}

export type TotalKeyURL =
  | keyCorporates
  | keySessionManager
  | KeyURL
  | KeyUserURL
  | KeyEnrollmentRemainderURL
  | KeyEnrollmentSuggestedURL
  | KeyEnrollmentURL
  | KeyPathsURL
  | KeyCoursesURL
  | KeyCertificateBadgesURL
  | KeyActivitiesURL
  | KeySmartConfiguratorURL
  | KeyPermissionsURL
  | KeyEditionURL
  | keyOnboarding
  | keyMediaManager
  | keyAssociatedLo
  | keyWrapper
  | keyCommunity
  | keyUsersWaiting
  | keyIndustries
  | keyProfessions
  | keyJobs
  | keyKnowledgeAreas
  | keyKnowledgeDomains
  | keyCapabilities
  | keyAttributes
  | KeyknowledgeDomainJobs
  | keyRuntastic
  | "getLanguages"
  | "getRoles"
  | "smartconfiguratorTranslation"
  | "uploadMultilanguage"
  | "downloadMultilanguage"
  | "startImpersonation"
  | "initiativeLanguages"
  | "corporateLanguages"
  | keySuggestionsKnowledgeDomains
  | keySuggestionsCapabilities
  | keySurvey
  | keyNotifications
  | keyTranslations
  | keyTeachersAreaExercise
  | keyTeachersAreaExerciseAssociation
  | keyTeachersAreaRevision
  | keyTeachersAreaReport
  | keyEditionTOJ
  | keySelfSignupRules
  | keySelfSignupSteps
  | keySoftwareVersioning
  | keyGroupsEnrolledCatalog
  | KeyDashboardURL
  | keyTIMCatalogueExcalibur
  | keyFoundedTraining
  | "collectCampaigns"
  | keyFoundedTraining
  | keyCollectCampaigns
  | keyCommunityClusters
  | keyLeaderboardClusters
  | keyBudgetsURL;
